export enum ColumnIds {
  LAST_PHARMACY_NOTE_DATE = 'last_pharmacy_note_date',
  LAST_ADMISSION = 'last_admission',
  PRIORITY = 'priority',
  PATIENT_NAME_AGE_UR = 'patient_name_age_ur',
  LOCATION = 'location',
  ADMITTING_DOCTOR = 'admitting_doctor',
  TAGS_PREFERENCES = 'tags_preferences',
  RENAL_FUNCTION = 'renal_function',
  NO_MEDS = 'no_meds',
  REASON_FOR_ADMISSION = 'reason_for_admission',
  EPISODE_CLOSED_DATE = 'episode_closed_date',
  CARE_PROGRESS = 'care_progress',
  ASSIGNED = 'assigned',
  ALLERGIES = 'allergies',
  ROUTE_MODIFIERS = 'route_modifiers',
  SERVICE = 'service',
  TEAM = 'team',
  ADMISSION_STATUS = 'admission_status',
  ADMISSION_DATE = 'admission_date',
  GOAL_OF_ADMISSION = 'goal_of_admission',
  LENGTH_OF_STAY = 'length_of_stay',
  FAVOURITE = 'favourite',
  CAREMAPPR_ID = 'caremappr_id',
  NAME_UR = 'name_ur',
  PHENOTYPE = 'phenotype',
  DOB_AGE = 'dob_age',
  DIAGNOSIS = 'diagnosis',
  TRIAGE_CATEGORY = 'triage_category',
  LAST_EREFERRAL = 'last_ereferral',
  ACTIVE_INSIGHTS = 'active_insights',
  MYPAINHEALTH_APP_ELIGIBILITY = 'mypainhealth_app_eligibility',
  MYPAINHEALTH_INVITED = 'mypainhealth_invited',
  MYPAINHEALTH_CONSENT = 'mypainhealth_consent',
  MYPAINHEALTH_LAST_LOGIN = 'mypainhealth_last_login',
}

export type DashboardColumnPlugin = {
  id: ColumnIds;
  title: string;
};

export const dashboardColumnPlugins: ReadonlyArray<DashboardColumnPlugin> =
  Object.freeze([
    { id: ColumnIds.LAST_PHARMACY_NOTE_DATE, title: 'Last Pharmacy event' },
    { id: ColumnIds.LAST_ADMISSION, title: 'Last admission' },
    { id: ColumnIds.PRIORITY, title: 'Priority' },
    { id: ColumnIds.PATIENT_NAME_AGE_UR, title: 'Name' },
    { id: ColumnIds.LOCATION, title: 'Location' },
    { id: ColumnIds.ADMITTING_DOCTOR, title: 'Admitting Dr' },
    { id: ColumnIds.TAGS_PREFERENCES, title: 'Tags' },
    { id: ColumnIds.RENAL_FUNCTION, title: 'Renal function' },
    { id: ColumnIds.NO_MEDS, title: 'No. meds' },
    { id: ColumnIds.REASON_FOR_ADMISSION, title: 'Reason for admission' },
    { id: ColumnIds.EPISODE_CLOSED_DATE, title: 'D/C Date' },
    { id: ColumnIds.CARE_PROGRESS, title: 'CARE PROGRESS' },
    { id: ColumnIds.ASSIGNED, title: 'Assigned' },
    { id: ColumnIds.ALLERGIES, title: 'Allergies' },
    { id: ColumnIds.ROUTE_MODIFIERS, title: 'Route modifiers' },
    { id: ColumnIds.SERVICE, title: 'Service' },
    { id: ColumnIds.TEAM, title: 'Team' },
    { id: ColumnIds.ADMISSION_STATUS, title: 'Admission Status' },
    { id: ColumnIds.ADMISSION_DATE, title: 'Admission Date' },
    { id: ColumnIds.GOAL_OF_ADMISSION, title: 'Goal of admission' },
    { id: ColumnIds.LENGTH_OF_STAY, title: 'Length of stay' },
    { id: ColumnIds.FAVOURITE, title: 'Favourite' },
    { id: ColumnIds.NAME_UR, title: 'Name + UR' },
    { id: ColumnIds.PHENOTYPE, title: 'Phenotype' },
    { id: ColumnIds.DOB_AGE, title: 'DoB and age' },
    { id: ColumnIds.DIAGNOSIS, title: 'Diagnosis' },
    { id: ColumnIds.TRIAGE_CATEGORY, title: 'Triage category' },
    { id: ColumnIds.LAST_EREFERRAL, title: 'Last eReferral' },
    { id: ColumnIds.ACTIVE_INSIGHTS, title: 'Active insights' },
    {
      id: ColumnIds.MYPAINHEALTH_APP_ELIGIBILITY,
      title: 'mypainhealth app eligibility',
    },
    { id: ColumnIds.MYPAINHEALTH_INVITED, title: 'Invited' },
    { id: ColumnIds.MYPAINHEALTH_CONSENT, title: 'Consent' },
    { id: ColumnIds.MYPAINHEALTH_LAST_LOGIN, title: 'Last login' },
  ]);

//for column display purpose
export const ColumnIdToTitle = Object.freeze(
  Object.fromEntries(
    dashboardColumnPlugins.map((p) => [p.id, p.title] as const),
  ) as Record<ColumnIds, string>,
);
